module.exports = __webpack_public_path__ + "img/advantage3.e90cb7ac.png";